var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-dropleft-circle",
    "data-name": "Icon ionic-ios-arrow-dropleft-circle",
    d: "M9.375,3.375a6,6,0,1,1-6,6A6,6,0,0,1,9.375,3.375ZM8.123,11.714a.559.559,0,0,0,0,.788.55.55,0,0,0,.392.162.56.56,0,0,0,.4-.164l2.712-2.72a.556.556,0,0,0-.017-.767L8.853,6.251a.557.557,0,0,0-.788.787l2.363,2.337Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRound);
export default __webpack_public_path__ + "static/media/arrowRound.7a12611a5319b020b993c6b8f798fa3f.svg";
export { ForwardRef as ReactComponent };